export default "__VITE_ASSET__BJ9ZW7CG__"